export const getPeriodEyeOptions = (hasFinance, hasBaseline, hasLimitedFinancialAccess, hasRetainerPeriodRead) => {
	const addChainingMethods = array => {
		array.add = nextOptions => {
			const newArray = array.concat(nextOptions);
			addChainingMethods(newArray);
			return newArray;
		};

		array.addIfHasFinance = nextOptions => {
			if (hasFinance) {
				const newArray = array.concat(nextOptions);
				addChainingMethods(newArray);
				return newArray;
			}
			return array;
		};
		array.addIfNotLimitedFinancialAccess = nextOptions => {
			if (!hasLimitedFinancialAccess) {
				const newArray = array.concat(nextOptions);
				addChainingMethods(newArray);
				return newArray;
			}
			return array;
		};
		array.addIfHasBaseline = nextOptions => {
			if (hasBaseline) {
				const newArray = array.concat(nextOptions);
				addChainingMethods(newArray);
				return newArray;
			}
			return array;
		};
		array.addIfHasRetainerPeriodRead = nextOptions => {
			if (hasRetainerPeriodRead) {
				const newArray = array.concat(nextOptions);
				addChainingMethods(newArray);
				return newArray;
			}
			return array;
		};
	};

	const createArray = () => {
		const options = [];
		addChainingMethods(options);
		return options;
	};

	return createArray()
		.add([
			{
				name: 'projectOverview',
				translationId: 'project_budget.project_overview',
				disabled: false,
				checked: true,
				nestedOptions: [
					{
						name: 'winProbability',
						checked: true,
						disabled: false,
						translationId: 'project.win_chance',
					},
					{
						name: 'dates',
						checked: true,
						disabled: false,
						translationId: 'common.dates',
					},
					{
						name: 'client',
						checked: false,
						disabled: false,
						translationId: 'insights.component.list.column.client',
					},
					{
						name: 'status',
						checked: false,
						disabled: false,
						translationId: 'common.status',
					},
					{
						name: 'projectOwner',
						checked: false,
						disabled: false,
						translationId: 'common.project_owner',
					},
					{
						name: 'stage',
						checked: false,
						disabled: false,
						translationId: 'insights.component.list.column.status',
					},
					{
						name: 'allocations',
						checked: false,
						disabled: false,
						translationId: 'scheduling.menu.allocations',
					},
					{
						name: 'budgetType',
						checked: false,
						disabled: false,
						translationId: 'new_project_modal.budget_type',
					},
					{
						name: 'rateCard',
						checked: false,
						disabled: false,
						translationId: 'insights.component.list.column.rateCard',
					},
					{
						name: 'progress',
						checked: false,
						disabled: false,
						translationId: 'common.progress',
					},
					{
						name: 'progressEom',
						checked: false,
						disabled: false,
						translationId: 'common.progress.eom',
					},
				],
			},
			{
				name: 'projectHours',
				translationId: 'project_portfolio_report.project_hours',
				disabled: false,
				checked: false,
				nestedOptions: createArray()
					.add([
						{
							name: 'registeredHours',
							checked: false,
							disabled: false,
							translationId: 'common.registered',
						},
						{
							name: 'remainingHours',
							checked: false,
							disabled: false,
							translationId: 'common.remaining',
						},
						{
							name: 'forecastedHours',
							checked: false,
							disabled: false,
							translationId: 'common.forecasted',
						},
						{
							name: 'totalScope',
							checked: false,
							disabled: false,
							translationId: 'project_portfolio_report.total_scope',
						},
						{
							name: 'approvedScope',
							checked: false,
							disabled: false,
							translationId: 'project_portfolio_report.approved_scope',
						},
					])
					.addIfHasBaseline([
						{
							name: 'baselineHours',
							checked: false,
							disabled: false,
							translationId: 'baseline.baseline',
						},
					]),
			},
			{
				name: 'labels',
				checked: false,
				disabled: false,
				translationId: 'common.labels',
			},
		])
		.addIfHasFinance([
			{
				name: 'financials',
				translationId: 'project_budget.financials',
				disabled: false,
				checked: false,
				nestedOptions: createArray()
					.addIfHasBaseline([
						{
							name: 'baseline',
							translationId: 'project_section.baseline',
							disabled: false,
							checked: false,
							nestedOptions: createArray()
								.add([
									{
										name: 'baselineRevenue',
										checked: false,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'baselineCost',
										checked: false,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'baselineProfit',
										checked: false,
										disabled: false,
										translationId: 'project_budget.profit',
									},
									{
										name: 'baselineMargin',
										checked: false,
										disabled: false,
										translationId: 'project_budget.margin',
									},
								]),
						},
					])
					.add([
						{
							name: 'invoice',
							translationId: 'common.invoiced',
							disabled: false,
							checked: false,
							nestedOptions: [
								{
									name: 'invoiced',
									checked: false,
									disabled: false,
									translationId: 'common.invoiced',
								},
								{
									name: 'paid',
									checked: false,
									disabled: false,
									translationId: 'common.invoice.paid',
								},
							],
						},
						{
							name: 'fixedPrice',
							translationId: 'project_budget.fixed_price',
							disabled: false,
							checked: true,
							nestedOptions: [
								{
									name: 'fixedPriceRevenue',
									checked: true,
									disabled: false,
									translationId: 'project_budget.revenue',
								},
							],
						},
						{
							name: 'actual',
							translationId: 'project_budget.actuals',
							disabled: false,
							checked: true,
							nestedOptions: createArray()
								.add([
									{
										name: 'actualRevenue',
										checked: true,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'actualCost',
										checked: true,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'actualProfit',
										checked: true,
										disabled: false,
										translationId: 'project_budget.profit',
									},
									{
										name: 'actualMargin',
										checked: false,
										disabled: false,
										translationId: 'project_budget.margin',
									},
								]),
						},
						{
							name: 'planned',
							translationId: 'common.plan',
							disabled: false,
							checked: true,
							nestedOptions: createArray()
								.add([
									{
										name: 'planRevenue',
										checked: true,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'planCost',
										checked: true,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'planProfit',
										checked: true,
										disabled: false,
										translationId: 'project_budget.profit',
									},
									{
										name: 'planMargin',
										checked: true,
										disabled: false,
										translationId: 'project_budget.margin',
									},
								]),
						},

						{
							name: 'remaining',
							translationId: 'common.remaining',
							disabled: false,
							checked: false,
							nestedOptions: createArray()
								.add([
									{
										name: 'remainingRevenue',
										checked: false,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'remainingCost',
										checked: false,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'remainingProfit',
										checked: false,
										disabled: false,
										translationId: 'project_budget.profit',
									},
									{
										name: 'remainingMargin',
										checked: false,
										disabled: false,
										translationId: 'project_budget.margin',
									},
								]),
						},
						{
							name: 'forecasted',
							translationId: 'common.forecasted',
							disabled: false,
							checked: true,
							nestedOptions: createArray()
								.add([
									{
										name: 'forecastedRevenue',
										checked: true,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'forecastedCost',
										checked: true,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'forecastedProfit',
										checked: true,
										disabled: false,
										translationId: 'project_budget.profit',
									},
									{
										name: 'forecastedMargin',
										checked: false,
										disabled: false,
										translationId: 'project_budget.margin',
									},
								]),
						},
						{
							name: 'actualPlan',
							translationId: 'project_budget.actual_vs_plan',
							disabled: false,
							checked: false,
							nestedOptions: createArray()
								.add([
									{
										name: 'actualPlanRevenue',
										checked: false,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'actualPlanCost',
										checked: false,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'actualPlanProfit',
										checked: false,
										disabled: false,
										translationId: 'project_budget.profit',
									},
								]),
						},
						{
							name: 'forecastedPlan',
							translationId: 'project_budget.forecast_vs_plan',
							disabled: false,
							checked: false,
							nestedOptions: createArray()
								.add([
									{
										name: 'forecastedPlanRevenue',
										checked: false,
										disabled: false,
										translationId: 'project_budget.revenue',
									},
								])
								.addIfNotLimitedFinancialAccess([
									{
										name: 'forecastedPlanCost',
										checked: false,
										disabled: false,
										translationId: 'project_budget.cost',
									},
									{
										name: 'forecastedPlanProfit',
										checked: false,
										disabled: false,
										translationId: 'project_budget.profit',
									},
								]),
						},
					])
					.addIfNotLimitedFinancialAccess([
						{
							name: 'invoicedActual',
							translationId: 'project_budget.invoice_vs_actual',
							disabled: false,
							checked: false,
							nestedOptions: createArray().add([
								{
									name: 'invoicedActualInvoiced',
									checked: false,
									disabled: false,
									translationId: 'project_budget.invoiced',
								},
								{
									name: 'invoicedActualRevenue',
									checked: false,
									disabled: false,
									translationId: 'project_budget.revenue',
								},
								{
									name: 'invoicedActualAccrued',
									checked: false,
									disabled: false,
									translationId: 'project_budget.accrued',
								},
							]),
						},
					])
					.addIfHasRetainerPeriodRead([
						{
							name: 'retainerPeriodTarget',
							translationId: 'project_budget.retainer_period_target',
							disabled: false,
							checked: false,
							nestedOptions: createArray().add([
								{
									name: 'retainerPeriodTargetMinutes',
									checked: false,
									disabled: false,
									translationId: 'project_budget.retainer_period_target_minutes',
								},
								{
									name: 'retainerPeriodTargetPrice',
									checked: false,
									disabled: false,
									translationId: 'project_budget.retainer_period_target_price',
								},
							]),
						},
					]),
			},
		]);
};
